import React from 'react';
import TelegramLoginButton from 'react-telegram-login';
import axios from 'axios';

const botName = "mdh_oficios_bot"
/* 
{
  "id": 868398235,
  "first_name": "Damián",
  "username": "damianegreco",
  "photo_url": "https://t.me/i/userpic/320/5CoQDE6-2CEct-gp0TgGUkZI4XbhqFnw9uGiGR-RIGI.jpg",
  "auth_date": 1688753470,
  "hash": "eb37209b34c63e037d8485ed9376840272c58497c4643dcf3a5ce0b345a06b5a"
}
*/

const asociarChat = function(telegram_id){
  return new Promise((resolve, reject) => {
    const url = localStorage.getItem('apiUrl') + '/telegram/asociar';
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    axios.post(url, {telegram_id}, config)
    .then((res) => {
      if (res.data.status === "ok") resolve(res.data)
      reject(res.data.error)
    })
    .catch((error) => reject(error));
  })
}

const getChatId = function(){
  return new Promise((resolve, reject) => {
    const url = localStorage.getItem('apiUrl') + '/telegram/check';
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    axios.get(url, config)
    .then((res) => {
      if (res.data.status === "ok") resolve(res.data.chatId)
      reject(res.data.error)
    })
    .catch((error) => reject(error));
  })
}
const desvincularChat = function(){
  return new Promise((resolve, reject) => {
    const url = localStorage.getItem('apiUrl') + '/telegram/desvincular';
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    axios.post(url,{}, config)
    .then((res) => {
      if (res.data.status === "ok") resolve()
      reject(res.data.error)
    })
    .catch((error) => reject(error));
  })
}
const testearChat = function(){
  return new Promise((resolve, reject) => {
    const url = localStorage.getItem('apiUrl') + '/telegram/testear';
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    axios.post(url,{}, config)
    .then((res) => {
      if (res.data.status === "ok") resolve()
      reject(res.data.error)
    })
    .catch((error) => reject(error));
  })
}

export default class Telegram extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      vinculado: false
    }
  }

  componentDidMount(){
    this.actualizar()
  }

  actualizar(){
    getChatId()
    .then((chatId) => {
      this.setState({vinculado:chatId !== null})
    })
    .catch((error) => {
      console.log(error);
      alert("Ocurrió un error");
    })
  }

  autoriza(resp){
    asociarChat(resp.id)
    .then(() => {
      alert("Fue asociado el chat");
      this.actualizar()
    })
    .catch((error) => {
      console.log(error);
      alert("Ocurrió un error");
    })
  }

  desvincular(){
    desvincularChat()
    .then(() => {
      alert("Chat desasociado");
      this.actualizar()
    })
    .catch((error) => {
      console.log(error);
      alert("Ocurrió un error");
    })
  }

  testear(){
    testearChat()
    .then(() => {
      alert("Mensaje enviado");
      this.actualizar()
    })
    .catch((error) => {
      console.log(error);
      alert("Ocurrió un error");
    })
  }

  render(){
    const {vinculado} = this.state;
    return(
      <div className="Todo Configuraciones">
        <div className="TramitesTodo">
          <h3>Telegram</h3>
        </div>
        {!vinculado && 
          <div style={{width:'90%', display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'center', marginBottom:10}}>
            <TelegramLoginButton dataOnauth={(resp) => this.autoriza(resp)} botName={botName} language="es" lang="es"/>
            {/* <script src="https://telegram.org/js/telegram-widget.js?22" data-telegram-login="mdh_oficios_bot" data-size="large" data-radius="10" data-auth-url="" data-request-access="write"></script> */}
          </div>
        }
        {vinculado && 
          <>
            <span style={{fontWeight:'bold', fontSize:18, margin:20}}>
              Se encuantra asociado a telegram
            </span>
            <span 
              style={{padding: '20px 30px', width:200, color:'#FAFAFA', textAlign:'center', margin:10, borderRadius:20, backgroundColor:'#6EA498', fontWeight:'bold', fontSize:18, cursor:'pointer'}} 
              onClick={()=> this.testear()}
            >
              Testear chat
            </span>
            <span 
              style={{padding: '20px 30px', width:200, textAlign:'center', margin:10, borderRadius:20, backgroundColor:'#F8A6AC', fontWeight:'bold', fontSize:18, cursor:'pointer'}} 
              onClick={()=> this.desvincular()}
            >
              Eliminar chat vinculado
            </span>
          </>
        }
      </div>
    )
  }
}